<template>
  <div class="container soc-tips-page">
    <div class="tips-box">
      <div class="tips-title">车辆可充至：</div>
      <div class="tips-p">涓流充电至SOC: <span class="soc-number">{{$route.query.soc || 100 }}％</span> 将自动停机并结算</div>
      <div class="tips-p">针对直流充电设施，主要用以解决新能源车辆在过度充电时，车辆充电管理系统（BMS）未自动断充，导致电池内部形成结晶击穿正负极隔膜，引起动力电池短路起火的可能。</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'money-tips',
  data(){
    return{

    }
  },
  
}
</script>
<style lang="less">
.soc-tips-page{
  padding: 0.17rem 0.20rem;
  background: #fff;
  min-height: 100%;
  box-sizing: border-box;
  .tips-box{
    margin-top: 0.40rem;
  }
  .tips-box:first-child{
    margin-top: 0;
  }
  .tips-title{
    font-size: 0.36rem;
    line-height: 0.50rem;
    color: #373A44;
  }
  .tips-p{
    margin-top: 0.20rem;
    font-size: 0.30rem;
    line-height: 0.42rem;
    color: #666;
  }
  .soc-number{
    color: #373A44;
    font-size: 0.36rem;
  }
}
</style>